import useServiceMetrics from "src/organization/pages/project/environment/metrics/hooks/useMetric";
import useGridPoller from "src/organization/pages/project/environment/metrics/resources/grid/useGridPoller";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

const useSwitchPoller = (serviceName: string, timeFrame: TimeFrameType) => {
  const client = useObservabilityPipelineHttpClient();

  const chorus = useServiceMetrics(serviceName, timeFrame);

  const obs = useGridPoller({
    serviceName,
    timeFrame
  });

  const obsInstances =
    (obs.data?.instances?.length || 0) > 1
      ? // When there are multiple instances, we append "average" to represent their combined average.
        // For a single instance, we return it as-is without modification.
        [...(obs.data?.instances || []), "average"]
      : obs.data?.instances || [];

  return {
    metrics: client ? obs.data?.metrics : chorus.data,
    instances: client ? obsInstances : chorus.instances[serviceName] || [],
    status: client ? obs.status : chorus.status,
    lastUpdated: client ? obs.lastUpdated : chorus.lastUpdated
  };
};

export default useSwitchPoller;
